import React from 'react'
import { faSquareFacebook, faInstagram, faLinkedin, faYoutube, faXTwitter, faThreads } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import allianceLogo from '../img/alliance-for-energy-innovation-fy26-logo-black.svg'
import departmentOfEnergyLogo from '../img/u-s-department-of-energy.svg'

export default function () {
  return (
        <footer id="footer" class="hidden-print">
        
        <div class="footertop">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-5">
                        <a href="https://www.nlr.gov"><strong>National Laboratory of the Rockies</strong></a>
                    </div>
                    <div class="col col-lg-7">
                        <div class="d-flex flex-column flex-lg-row justify-content-lg-start global">
                            <div><a href="https://www.nlr.gov/about">About</a></div>
                            <div><a href="https://www.nlr.gov/research">Research</a></div>
                            <div><a href="https://www.nlr.gov/workingwithus">Work with Us</a></div>
                            <div><a href="https://www.nlr.gov/news">News</a></div>
                            <div><a href="https://www.nlr.gov/careers">Careers</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footerbottom">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-lg-5">
                        <div><a  id="contact-link" href="/contact">Contact Us</a></div>
                        <div class="mt-2"><a href="https://www.nlr.gov/about/visiting-nlr">Visit</a></div>
                        <div class="mt-2"><a href="https://www.nlr.gov/news/subscribe">Subscribe to NLR</a></div>
                        <div class="mt-3">
                            <ul class="social-links list-inline">
                                <li class="list-inline-item"><a href="https://www.facebook.com/nationallaboratoryoftherockies" aria-label="Follow NLR on Facebook"><FontAwesomeIcon icon={faSquareFacebook} /></a>
                                </li>
                                <li class="list-inline-item"><a href="https://www.instagram.com/natlabrockies/" aria-label="Follow NLR on Instagram"><FontAwesomeIcon icon={faInstagram} /></a></li>
                                <li class="list-inline-item"><a href="https://www.linkedin.com/company/national-lab-of-the-rockies/"
                                    aria-label="Follow NLR on Linked In"><FontAwesomeIcon icon={faLinkedin} /></a>
                                </li>
                                <li class="list-inline-item"><a href="https://www.youtube.com/@nationallaboratoryoftherockies" aria-label="Follow NLR on YouTube"><FontAwesomeIcon icon={faYoutube} /></a>
                                </li>
                                <li class="list-inline-item"><a href="https://x.com/NatLabRockies" aria-label="Follow NLR on X"><FontAwesomeIcon icon={faXTwitter} /></a>
                                </li>
                                <li class="list-inline-item"><a href="https://www.threads.com/@natlabrockies" aria-label="Follow NLR on Threads"><FontAwesomeIcon icon={faThreads} /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-8 col-lg-7 globalsecondary" style={{lineHeight: '1.65rem'}}>
                        <div class="row">
                            <div class="col-sm-6 col-lg-3">
                                <div class="mt-1"><a href="https://www.nlr.gov/accessibility">Accessibility</a></div>
                                <div class="mt-1"><a href="https://www.nlr.gov/disclaimer">Disclaimer</a></div>
                                <div class="mt-1"><a href="https://www.nlr.gov/security">Security and Privacy</a></div>
                                <div class="mt-1"><a href="https://www.nlr.gov/webmaster">Site Feedback</a></div>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                
                                <div class="mt-1"><a href="https://developer.nlr.gov/">Developers</a></div>
                                <div class="mt-1"><a href="https://thesource.nlr.gov/">Employees</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="mt-4">
                <div class="row">
                    <div class="col-lg-5">
                        <a href="https://www.alliance-for-energy-innovation.org/"><img class="mb-3" src={allianceLogo} alt="Alliance for Sustainable Energy, LLC" width={145} /></a>
                        <a href="https://energy.gov"><img class="ml-5" src={departmentOfEnergyLogo} alt="U.S. Department of Energy" width={175} /></a>
                    </div>
                    <div class="col-12 col-lg-7 mt-3 mt-lg-0">
                        <p class="nlr-attr" style={{marginTop: '1rem'}}>The National Laboratory of the Rockies is a national laboratory of the U.S. Department of Energy, Office of Critical Minerals and Energy Innovation, operated under Contract No. DE-AC36-08GO28308.</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
        
    </footer>
  )
}